import { Navigate, useRoutes } from 'react-router-dom';

//
import {
  Page404,
  Home,
  MarketPlace,
  MarketPlaceDetails,
  Games,
} from './elements';
import CompactLayout from '../layouts/compact';
import CustomLayout from '../layouts/normal-pages/CustomLayout';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <CustomLayout />,
      children: [
        { path: '', element: <Home /> },
        { path: 'market-place', element: <MarketPlace /> },
        { path: 'market-place/:axieId', element: <MarketPlaceDetails /> },
        { path: 'games', element: <Games /> },
      ],
    },

    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
